// Pricing 定价页面翻译

export const pricing = {
    // Page title and subtitle
    chooseYourPlan: 'Choose Your Plan',
    selectPerfectPlan: 'Select the perfect plan for your creative needs',
    
    // Billing cycle
    yearly: 'Yearly',
    monthly: 'Monthly',
    year: 'year',
    month: 'month',
    pack: 'pack',
    
    // Credit packs
    creditPacks: 'Credit Packs',
    
    // Plan status
    mostPopular: 'Most Popular',
    currentPlan: 'Current Plan',
    
    // Actions
    buyNow: 'Buy Now',
    subscribe: 'Subscribe',
    subscribeStarter: 'Subscribe to Starter',
    subscribePro: 'Subscribe to Pro',
    subscribePremium: 'Subscribe to Premium',
    subscribeNow: 'Subscribe Now',
    processing: 'Processing...',
    retry: 'Retry',
    cryptoPayment: 'Pay with Crypto',
    
    // Loading states
    loading: 'Loading pricing plans...',
    unableToLoadPlans: 'Unable to load pricing plans',
    noPlansAvailable: 'No Plans Available',
    noPlansMessage: 'No {billingCycle} plans are currently available.',
    
    // Security and help
    securePayment: 'Secure payment powered by Stripe',
    needHelp: 'Need help? Contact our support team',
    
    // FAQ
    faqTitle: 'Frequently Asked Questions',
    faqSubtitle: 'Find answers to common questions about our pricing and plans',
    
    faq1Question: 'Can I change my plan at any time?',
    faq1Answer: 'Yes, you can upgrade or downgrade your plan at any time. Changes will be reflected in your next billing cycle.',
    
    faq2Question: 'What payment methods do you accept?',
    faq2Answer: 'We accept all major credit cards, PayPal, and other payment methods through our secure Stripe integration.',
    
    faq3Question: 'Is there a free trial available?',
    faq3Answer: 'Yes, all new users receive free credits upon registration to try our services.',
    
    faq4Question: 'Can I cancel my subscription anytime?',
    faq4Answer: 'Yes, you can cancel your subscription at any time. You will continue to have access until the end of your current billing period.',
    
    faq5Question: 'Do unused credits roll over?',
    faq5Answer: 'Credits from subscription plans will be cleared at the end of each billing cycle and do not roll over. However, credits purchased through credit packs do not expire.',
    
    faq6Question: 'Is there a discount for annual plans?',
    faq6Answer: 'Yes, annual plans offer significant savings compared to monthly billing. The discount is automatically applied.'
  };
